import numeral from 'numeral';

/**
 * Formats a number into Facebook-style compact format
 * @param count - The number to format
 * @returns Formatted string like "1.2K", "5M", etc.
 * @example
 * formatLikeCount(523) // "523"
 * formatLikeCount(1500) // "1.5K"
 * formatLikeCount(1000000) // "1M"
 */
export function formatLikeCount(count: number): string {
  if (count < 1000) {
    return count.toString();
  }
  return numeral(count).format('0.[0]a').toUpperCase();
}
